<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :key_sku="keySku"
      :key_spu="keySpu"
      :key_status="keyStatus"
      :key_soldstatus="keySoldStatus"
      :key_name="keyName"
      :date_from="dateFrom"
      :date_to="dateTo"
      :userInfo="userInfo"
      @changeStatus="changeLeftSideStatus"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :status="leftSideStatus"
        :key_sku="keySku"
        :key_spu="keySpu"
        :key_status="keyStatus"
        :key_soldstatus="keySoldStatus"
        :key_name="keyName"
        :date_from="dateFrom"
        :date_to="dateTo"
        :userInfo="userInfo"
        @clearKey="clearKey"
      />
      <router-view
        :first_loading="firstLoading"
        :items="items"
        @delNewProduct="delNewProduct"
        @channelType="channelType"
        @changeChecked="changeChecked"
        :check_arr="checkArr"
        @sortList="sortList"
        :sort2="sorts"
        :sort_type2="sortType2"
        @mgrImg="openMgrImg"
      ></router-view>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/oem-new-products/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
    </div>
    <api-loading :show="loading"></api-loading>
    <Modal
      :modalId="'modalDelNewProduct'"
      :home="false"
      :loading="modalDelNewProduct.loading"
      :size="'sm'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("product.删除推荐新品") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <p class="tx-danger">
            {{ $t("product.确定要删除以下推荐新品么？") }}
          </p>
          <p class="tx-ellipsis2">{{ modalDelNewProduct.name }}</p>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-danger
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="del"
            >
              {{ $t("product.删除") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("product.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <!-- 新图片管理 -->
    <ModalUploadProductImages
      :open="openUploadProductImages"
      :imgRule="uploadPImgData.imgRule"
      :sku="uploadPImgData.sku"
      :minSelected="uploadPImgData.min"
      :maxSelected="uploadPImgData.max"
      :loading="uploadPImgData.loading"
      :spuId="uploadPImgData.spuId"
      :spuImages="uploadPImgData.spuImages"
      :stocks="uploadPImgData.stocks"
      :spu="uploadPImgData.spu"
      :type="1"
      @save="uploadProductImgSave"
    />
  </div>
</template>

<script>
import LeftSide from "./left-side.vue";
import Header from "./header.vue";
import Modal from "@components/Modal";
// 删除确认
import { confirmComponent } from "@components/components.js";
import { pagination } from "@components/pagination.js";
// 选商品图片
import ModalUploadProductImages from "@components/supplier/modal-upload-product-images";

export default {
  data() {
    return {
      // 左边栏状态
      leftSideStatus: store.get("leftSideStatus"),
      loading: true,
      firstLoading: true,
      items: [],
      page: this.$route.params.page ? this.$route.params.page : 1,
      pageSizeSelect: [10, 20, 50],
      rowsPerPage: parseInt(store.get("oem-new-products-rowsPerPage"))
        ? parseInt(store.get("oem-new-products-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      keyStatus: "",
      keySoldStatus: "",
      keySku: "",
      keySpu: "",
      keyName: "",
      dateFrom: "",
      dateTo: "",
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      checkArr: [],
      sorts: "ASC",
      sorts2: "",
      sortType2: "timeCreated",
      modalDelNewProduct: {
        loading: false,
        id: "",
        name: "",
        status: "",
        sku: "",
      },
      openUploadProductImages: Symbol(),
      uploadPImgData: {
        loading: false,
        imgRule: null,
        sku: "",
        min: 1,
        max: "",
        spuId: "",
        spu: "",
        spuImages: [],
      },
      uploadPImgDataDefault: "{}",
    };
  },
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    confirmComponent,
    ModalUploadProductImages,
  },
  computed: {},
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("oem-new-products-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    openMgrImg(item, sku, max = 100, min = 8) {
      this.uploadPImgData = JSON.parse(this.uploadPImgDataDefault);
      this.uploadPImgData.imgRule = item.imgRule;
      this.uploadPImgData.sku = sku;
      if (item.imgRule && item.imgRule.isMust && !sku) {
        //$t('product.图片上传有限制')
        this.uploadPImgData.max = item.imgRule.quantityRule.split("||").pop();
        this.uploadPImgData.min = item.imgRule.quantityRule.split("||").shift();
      } else {
        this.uploadPImgData.max = max;
        this.uploadPImgData.min = min;
      }
      this.uploadPImgData.spu = item.sku;
      this.uploadPImgData.spuId = item.id;
      this.uploadPImgData.spuImages =
        item.propertyImage && item.propertyImage.length
          ? item.propertyImage
          : [];
      //    this.uploadPImgData.stocks = JSON.parse(JSON.stringify(item.stocks));
      //$t('product.打开')
      this.openUploadProductImages = Symbol();
    },
    uploadProductImgSave(spuid, spuImages, sku) {
      //$t('product.上传目录成功回调')
      if (!spuImages || !spuImages.length) {
        ShowTip(this.$t("product.至少设置一张图片"), "danger");
        return false;
      }
      this.uploadPImgData.loading = true;
      let params = {
        spuid,
      };
      let skuImages = {};
      if (sku) {
        //$t('product.只操作')sku
        this.uploadPImgData.stocks.forEach((e) => {
          if (e.sku == sku) skuImages[e.sku] = spuImages[0];
        });
        params.skuImages = skuImages;
      } else {
        this.uploadPImgData.stocks.forEach((e) => {
          skuImages[e.sku] = e.tempImg;
        });
        params.spuImages = spuImages;
        params.skuImages = skuImages;
      }
      $.api_call("api.SupplierStockSPU.saveImages", params, (r) => {
        this.uploadPImgData.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("product.图片设置成功"), "success");
          $("#modalUploadProductImages").modal("hide");
          this.updateSuccess(spuid);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    sortList(type, sort) {
      this.sortType2 = type;
      this.sorts2 = sort;
    },
    changeChecked(data) {
      this.checkArr = data;
    },
    channelType(item) {
      this.loading = true;
      $.api_call(
        "api.SupplierStockSPU.commitNewStocks",
        {
          sku: item.sku,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("product.推送给客户成功"), "success");
            this.updateSuccess(item.id);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    del() {
      this.modalDelNewProduct.loading = true;
      let apiUrl = "",
        params = { sku: this.modalDelNewProduct.sku };
      apiUrl = "api.SupplierStockSPU.delNewStocks";

      $.api_call(apiUrl, params, (r) => {
        this.modalDelNewProduct.loading = false;
        if (r.ErrorCode == "9999") {
          this.getList(true);
          ShowTip(this.$t("product.商品删除成功"), "success");
          $("#modalDelNewProduct").modal("hide");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    delNewProduct(item) {
      this.modalDelNewProduct.loading = false;
      this.modalDelNewProduct.id = item.id;
      this.modalDelNewProduct.sku = item.sku;
      this.modalDelNewProduct.name = item.name;
      this.modalDelNewProduct.status = item.status;
      $("#modalDelNewProduct").modal("show");
    },
    clearKey(type) {
      switch (type) {
        case "name":
          this.keyName = "";
          break;
        case "sku":
          this.keySku = "";
          break;
        case "spu":
          this.keySpu = "";
          break;
        case "status":
          this.keyStatus = "";
          break;
        case "soldStatus":
          this.keySoldStatus = "";
          break;
        case "date":
          this.dateFrom = this.dateTo = "";
          break;
      }
      this.toPage(1);
    },
    filtrate(keyName, keySku, keyStatus, keySpu, soldStatus, dateFrom, dateTo) {
      this.keyName = keyName;
      this.keySku = keySku;
      this.keyStatus = keyStatus;
      this.keySpu = keySpu;
      this.keySoldStatus = soldStatus;
      this.dateFrom = dateFrom;
      this.dateTo = dateTo;
      this.toPage(1);
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getList();
      this.checkArr = [];
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/oem-new-products/" + 1 });
      if (page == 1) {
        this.getList();
      }
      this.checkArr = [];
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/oem-new-products/" + num });
      if (page == num) {
        this.getList();
      }
      this.checkArr = [];
    },
    changeLeftSideStatus() {
      //改变$t('product.左边栏')状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    updateSuccess(id) {
      //$t('product.成功后获取新数据')
      $.api_call(
        "api.SupplierStockSPU.findNewStocks",
        {
          id: id,
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            if (r.Data.Results.length == 0) return;
            this.items.forEach((e, i) => {
              if (e.id == r.Data.Results[0].id) {
                this.items.splice(i, 1, r.Data.Results[0]);
              }
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getList(s) {
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        productStatus: this.keySoldStatus,
        status: this.keyStatus,
        sku: this.keySku,
        name: this.keyName,
        spu: this.keySpu,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      };
      $.api_call("api.SupplierStockSPU.findNewStocks", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
  mounted() {
    this.getList();
    this.uploadPImgDataDefault = JSON.stringify(this.uploadPImgData);
  },
};
</script>

<style lang="less" scoped>
.nav.nav-tabs {
  .nav-item {
    background-color: #fff;
    .nav-link {
      border-bottom-color: #ddd;
    }
    .nav-link:active,
    .nav-link.active {
      border-bottom: 1px solid transparent;
      color: inherit;
      background-color: #fff;
    }
    .nav-link:focus {
      color: #868ba1;
    }
    .nav-link:hover {
      background-color: #f0f0f0;
      color: #868ba1;
    }
    .nav-link.active:hover {
      background-color: #fff;
    }
  }
}
.tab-content {
  border: 1px #ddd solid;
  border-top: none;
  padding: 0 15px;
  .tab-container.active {
    display: block;
  }
  .tab-container {
    display: none;
  }
}

.modal-content {
  .sku-list {
    h3 {
      margin-bottom: 5px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
    }
  }
  tbody {
    font-size: 12px;
  }
  .pro-info {
    display: flex;
    .img-wrap {
      margin-right: 5px;
      max-width: 60px;
      max-height: 60px;
      min-width: 60px;
      min-height: 60px;
      border: 1px #ddd solid;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .right {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      max-width: 200px;
      min-width: 200px;
      line-height: 20px;
      .pro-attr {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .table-wrap {
    margin-bottom: 15px;
  }
  .new-return-bottom {
    border-top: 1px #ddd solid;
    padding: 15px 15px 0;
  }
  textarea {
    resize: none;
  }
}
.info-wrap {
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
.input-wrap {
  margin: 0 -15px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
</style>

